import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const FilterByExpirationDate = ({ value, onChange, label = "Filter by Expiration Status" }) => {
  return (
    <FormControl fullWidth variant="outlined" size="small" sx={{ maxWidth: 220 }}>
      <InputLabel id="expiration-status-filter-label">{label}</InputLabel>
      <Select
        labelId="expiration-status-filter-label"
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value={false}>Active</MenuItem>
        <MenuItem value={true}>Expired</MenuItem>
      </Select>
    </FormControl>
  );
};

export default FilterByExpirationDate;
